/**
 * rrweb 录制工具类
 * 用于记录用户操作行为并上传到服务器
 * 
 * @requires rrweb
 * @requires fflate
 * @requires qiniu-js
 */

import * as rrweb from 'rrweb';
import { zlibSync, strToU8 } from 'fflate';
import axios from 'axios'
import * as qiniu from 'qiniu-js';
// 创建请求实例
const request = axios.create({});
request.interceptors.request.use(
  (config) => {
    config.timeout = 10 * 1000; // 请求响应时间
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 添加响应拦截器
request.interceptors.response.use(
  (response) => {
    return Promise.resolve(response.data); // 使用Promise.resolve 正常响应
  },
  (error) => {
    return Promise.reject(error);
  }
);
const getToken = (data) => {
  return request({
    method: 'post',
    url: process.env.VUE_APP_QINIU_URL + "/openQiniu/getQiniuUpToken",
    data
  })
}
const monitorPicAdd = (data) => {
  return request({
    method: 'post',
    url: process.env.VUE_APP_HEDE_URL + "/api/monitor/pic/add",
    data
  })
}
let rrwebStop = null;
const rrwebArr = [];
let qiniuName = null;
export const startRecord = () => {
  if (rrwebStop) return;
  rrwebStop = rrweb.record({
    emit(event) {
      rrwebArr.push(event);
    }
  })
}
// 上传rrweb
const uploadRRweb = () => {
  const body = JSON.stringify(rrwebArr);
  rrwebArr.length = 0;
  const uint8ArrayContent = zlibSync(strToU8(body), { level: 9 })
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth() + 1;  // 月份从0开始，所以要加1
  const day = now.getDate();
  const hour = now.getHours();
  const minute = now.getMinutes();
  const second = now.getSeconds();
  const Random8 = Math.floor(10000000 + Math.random() * 90000000);

  const fileName = `${year}${month}${day}${hour}${minute}${second}-${Random8}`
  qiniuName = fileName
  const file = new File([uint8ArrayContent], fileName, { mime: 'text/plain', type: 'text/plain' })
  return uploadQiNiu(file, fileName, process.env.VUE_APP_BUCKET, 'text/plain')
}
const uploadQiNiu = (file, fileName, bucket, mimeType) => {
  return new Promise((resolve, reject) => (async () => {
    // 获取七牛token
    const res = await getToken({ bucket });
    const token = res.result.upToken;
    qiniu.upload(file, fileName, token, { mimeType }, {})
      .subscribe({
        next(val) {
          console.log('up => ', val);
        },
        complete(val) {
          console.log('up complete => ', val);
          resolve(val.key);
        },
        error(err) {
          console.log('up error => ', err);
          reject(err);
        }
      })
  })());
}
// 获取随机字符串
const generateRandomString = (length) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters[randomIndex];
  }
  return result;
}
export const stopRecord = async (creditCode) => {
  if (!rrwebStop) return;
  rrwebStop();
  await uploadRRweb();
  let par = {
    token: generateRandomString(18),
    userId: creditCode,
    path: 'https://qsgzstorage.hedejj.com/' + qiniuName,
    type: "rrweb"
  }
  await monitorPicAdd(par)
}




